// /**
//  * Orders - list
//  */

// React
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderBuilder from '../../utils/headerBuilder';
// Context
import AuthContext from '../../authContext';

// UI
import theme from '../../theme';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
  lighten,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
  Button,
  Typography,
  Tooltip,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Select,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiClose,
  mdiFileDocumentOutline,
  mdiPackageVariantClosed,
  mdiPencilOutline,
  mdiHistory,
  mdiChevronDown,
  mdiChevronUp,
  mdiAccountArrowLeftOutline,
  mdiPlusBoxMultipleOutline,
  mdiPackageVariant,
  mdiInformation,
} from '@mdi/js';

// Components
import Can from '../../components/Can';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../utils/rulesOrderStatus';

// Helper
import {
  translate,
  checkMatchMedia,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Order, Status } from './interfaces';
import showDeliveryType from '../../utils/temporaryConditions/showDeliveryType';
import showOrderTplType from '../../utils/temporaryConditions/showOrderTplType';

type Data = Order;
type Props = {
  data: any;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
};
type Ord = 'asc' | 'desc';

interface HeadCell {
  id: keyof Data;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
  numSelected: number;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiTableCell-root': {
        padding: '5px',
      },
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 650,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: 'space-between',
    },
    highlight:
      theme.palette.type === 'light'
        ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
    title: {
      // flex: '1 1 100%',
    },
  })
);

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

interface EnhancedTableToolbarProps {
  numSelected: number;
  setOpenChangeStatus: any;
  selected: any;
  data: any;
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const classes = useToolbarStyles();
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const { numSelected, selected, data } = props;

  const handleClickChangeStatus = () => {
    const selectedData = data.filter(
      (item: any) => selected.indexOf(item.id) > -1
    );

    if (!checkStatus(selectedData)) {
      setOpenAlertWarning(true);
    } else {
      props.setOpenChangeStatus(true);
    }
  };

  const checkStatus = (data: any) => {
    let sameStatus = true;
    data?.map((item: any) => {
      if (item?.status !== data[0]?.status) {
        return (sameStatus = false);
      }
      return item;
    });
    return sameStatus;
  };

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              {numSelected} انتخاب
            </Typography>
          ) : (
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            />
          )}
          {numSelected > 0 && (
            <Tooltip title="تغییر وضعیت">
              <Button
                size="small"
                variant="contained"
                onClick={handleClickChangeStatus}
                color="secondary"
              >
                تغییر وضعیت
              </Button>
            </Tooltip>
          )}
        </Toolbar>
      )}
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => setOpenAlertWarning(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد </DialogTitle>
        <DialogContent>
          وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {'متوجه شدم'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };
  let headCells: HeadCell[] = [];

  Can({
    role: authContext.user.role,
    perform: 'orders:tracking-code',
    yes: () => {
      headCells = [
        { id: 'partnerName', label: 'نام شرکت' },
        {
          id: 'customerName',
          label: 'سفارش‌دهنده',
        },
        {
          id: 'id',
          label: 'شناسه سفارش',
        },
        {
          id: 'items',
          label: 'تعداد آیتم‌های سفارش',
        },
        {
          id: 'deliveryDate',
          label: 'تاریخ تحویل',
        },
        { id: 'trackingCode', label: 'کد رهگیری' },
        { id: 'deliveryType', label: 'نوع ارسال' },
        { id: 'status', label: 'وضعیت' },
      ];
    },
    no: () => {
      headCells = [
        { id: 'partnerName', label: 'نام شرکت' },
        {
          id: 'customerName',
          label: 'سفارش‌دهنده',
        },
        {
          id: 'id',
          label: 'شناسه سفارش',
        },
        {
          id: 'items',
          label: 'تعداد آیتم‌های سفارش',
        },
        {
          id: 'deliveryDate',
          label: 'تاریخ تحویل',
        },
        { id: 'status', label: 'وضعیت' },
      ];
    },
  });

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              classes={{
                // Override with the active class if this is the selected column or inactive otherwise
                icon:
                  orderBy === headCell.id
                    ? classes.activeSortIcon
                    : classes.inactiveSortIcon,
              }}
              IconComponent={() => (
                <Icon
                  path={
                    orderBy === headCell.id && order === 'desc'
                      ? mdiChevronDown
                      : mdiChevronUp
                  }
                  size={0.7}
                  className={
                    orderBy === headCell.id
                      ? classes.activeSortIcon
                      : classes.inactiveSortIcon
                  }
                />
              )}
            >
              <span className={classes.columnText}>{headCell.label}</span>
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  const [selected, setSelected] = React.useState<string[]>([]);
  const [valueStatus, setValueStatus] = React.useState('');
  const [openChangeStatus, setOpenChangeStatus] = React.useState(false);

  const handleChangeValueStatus = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValueStatus((event.target as HTMLInputElement).value);
  };
  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.data.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const changeStatusOrder = () => {
    props.changeStatusOrderWhitId({
      ids: selected,
      status: `${valueStatus}`,
      description: null,
    });
  };

  return (
    <div className={classes.root}>
      <EnhancedTableToolbar
        numSelected={selected.length}
        setOpenChangeStatus={setOpenChangeStatus}
        selected={selected}
        data={props.data}
      />
      <Paper className={classes.paper}>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <HeaderBuilder
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.data.length}
              numSelected={selected.length}
              onSelectAllClick={handleSelectAllClick}
              filterVal={props.filterVal}
              onFilterValue={(filtervalues: any) => {
                props.onFilterValue(filtervalues);
              }}
              head={props.head}
              removeFilterHandler={props.removeFilterHandler}
              haveAction={true}
              filterLabelTranslator={props.filterLabelTranslator}
            />

            <TableBody>
              {props.data[0].warehouseType == 'MULTI' && props.data.length == 1
                ? stableSort(props.data[0].childOrders, getComparator(order, orderBy))
                  .slice()
                  .map((row: any, index: number) => {
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow key={index} hover role="checkbox" tabIndex={-1}>
                        <StyledTableCell id={labelId} scope="row" align="center">
                          {row.partnerName}
                        </StyledTableCell>
                        <StyledTableCell id={labelId} scope="row" align="center">
                          {row.customerName}
                        </StyledTableCell>
                        <StyledTableCell id={labelId} scope="row" align="center">
                          {row.id}
                          {row.parentId && `(${row.parentId})`}
                          {row.description && <HtmlTooltip title={row.description}>
                            <Icon path={mdiInformation} size={0.8}/>
                          </HtmlTooltip>}
                        </StyledTableCell>
                        <StyledTableCell id={labelId} scope="row" align="center">
                          {row.itemsCount}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <span>
                            {jMoment(row.deliveryDate, 'YYYY/M/D')
                              .locale('fa')
                              .format('jYY/jMM/jDD')}
                          </span>
                          &nbsp; &nbsp;- &nbsp; &nbsp;
                          <span>
                            {`${jMoment(row.deliveryStartTime, 'HH:mm:ss')
                              .locale('fa')
                              .format('HH')}
                        `}
                            {`تا ${jMoment(row.deliveryEndTime, 'HH:mm:ss')
                              .locale('fa')
                              .format('HH')}`}
                          </span>
                        </StyledTableCell>
                        <Can
                          role={authContext.user.role}
                          perform="orders:tracking-code"
                          yes={() => (
                            <React.Fragment>
                              <StyledTableCell
                                id={labelId}
                                scope="row"
                                align="center"
                              >
                                {row.trackingCode}
                              </StyledTableCell>
                              <StyledTableCell
                                id={labelId}
                                scope="row"
                                align="center"
                              >
                                {translate(row.deliveryType)}
                              </StyledTableCell>
                            </React.Fragment>
                          )}
                        />
                        <StyledTableCell align="center">
                          <Can
                            role={authContext.user.role}
                            perform="orders:changeOrderStatus"
                            yes={() => (
                              <FormControl style={{ width: '100%' }}>
                                <Icon
                                  path={mdiPencilOutline}
                                  size={1}
                                  className={classes.changStatusIcon}
                                />
                                <Select
                                  className={classes.changStatusBox}
                                  fullWidth
                                  name={`status${index}`}
                                  multiple
                                  id={row.rubikaId}
                                  value={[{}]}
                                  IconComponent={() => null}
                                  renderValue={() => (
                                    <span className={classes.renderValue}>
                                      {translate(row.status, 'order')}
                                    </span>
                                  )}
                                >
                                  <RadioGroup
                                    className={classes.radioGroup}
                                    aria-label={`status${index}`}
                                    name={`status${index}`}
                                    value={'item'}
                                    onChange={(
                                      e: React.ChangeEvent<{ value: unknown }>
                                    ) =>
                                      props.handleOpenConfirmUpdateState({
                                        id: row.id,
                                        body: `${e.target.value}`,
                                      })
                                    }
                                  >
                                    {rulesOrderStatus[row.status].map(
                                      (item: any, index: number) => (
                                        <FormControlLabel
                                          className={classes.radioGroupItem}
                                          key={index}
                                          checked={row.status === item}
                                          value={item}
                                          disabled={
                                            rulesAdminChangeOrderStatus[
                                              authContext.user.role
                                            ].indexOf(item) === -1
                                          }
                                          control={<Radio />}
                                          label={translate(item, 'order')}
                                        />
                                      )
                                    )}
                                  </RadioGroup>
                                </Select>
                              </FormControl>
                            )}
                            no={() => {
                              return (
                                <span>{translate(row.status, 'order')}</span>
                              );
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          <div>
                            {row.status === 'ASSIGNED' ? (
                              <Link
                                to={`/warehouse-operator-orders/${row.id}/pick`}
                              >
                                <IconButton
                                  aria-label="details"
                                  size="small"
                                  title="جمع آوری سفارش"
                                  data-cy="details"
                                >
                                  <Icon
                                    path={mdiPlusBoxMultipleOutline}
                                    size={1}
                                    color={theme.palette.orange.main}
                                  />
                                </IconButton>
                              </Link>
                            ) : null}
                            {row.status === 'PICKED' ? (
                              <Link
                                to={`/warehouse-operator-orders/${row.id}/pack`}
                              >
                                <IconButton
                                  aria-label="details"
                                  size="small"
                                  title="بسته بندی سفارش"
                                  data-cy="details"
                                >
                                  <Icon
                                    path={mdiPackageVariant}
                                    size={1}
                                    color={theme.palette.info.main}
                                  />
                                </IconButton>
                              </Link>
                            ) : null}
                            <Link to={`/orders/${row.id}`}>
                              <IconButton
                                aria-label="details"
                                size="small"
                                title="جزئیات سفارش"
                                data-cy="details"
                              >
                                <Icon
                                  path={mdiFileDocumentOutline}
                                  size={1}
                                  color={theme.palette.green.main}
                                />
                              </IconButton>
                            </Link>
                            <Can
                              role={authContext.user.role}
                              perform="orders:byBundle"
                              yes={() =>
                                row.status !== 'ORDERED' && row.status ? (
                                  <Link to={`/bundles/${row.bundleId}`}>
                                    <IconButton
                                      aria-label="bundle"
                                      size="small"
                                      title="نمایش سفارش در بسته "
                                      color="secondary"
                                    >
                                      <Icon
                                        path={mdiPackageVariantClosed}
                                        size={1}
                                        color={theme.palette.blue.main}
                                      />
                                    </IconButton>
                                  </Link>
                                ) : (
                                  <IconButton
                                    aria-label="bundle"
                                    size="small"
                                    title="بسته‌بندی نشده"
                                    disabled
                                    color="default"
                                    style={{ pointerEvents: 'fill' }}
                                  >
                                    <Icon
                                      path={mdiPackageVariantClosed}
                                      size={1}
                                    />
                                  </IconButton>
                                )
                              }
                            />
                            <Can
                              role={authContext.user.role}
                              perform="orders:history"
                              yes={() => (
                                <Link to={`/orders/${row.id}/alllogs`}>
                                  <IconButton size="small" title="تاریخچه سفارش">
                                    <Icon path={mdiHistory} size={1} />
                                  </IconButton>
                                </Link>
                              )}
                            />
                            <Can
                              role={authContext.user.role}
                              perform="order:assign"
                              yes={() => (
                                <Link to={`/assign-order/${row.id}`}>
                                  <IconButton size="small" title="اختصاص سفارش">
                                    <Icon
                                      color="#b297a7"
                                      path={mdiAccountArrowLeftOutline}
                                      size={1}
                                    />
                                  </IconButton>
                                </Link>
                              )}
                            />
                            <Can
                              role={authContext.user.role}
                              perform="orders:cancelOrders"
                              yes={() => (
                                <IconButton
                                  aria-label="cancele"
                                  title={
                                    row.status === 'CANCELLED'
                                      ? 'لغو شده'
                                      : 'لغو سفارش'
                                  }
                                  size="small"
                                  style={{ pointerEvents: 'fill' }}
                                  disabled={row.status === 'CANCELLED'}
                                >
                                  <Icon
                                    path={mdiClose}
                                    size={1}
                                    color={
                                      row.status !== 'CANCELLED'
                                        ? theme.palette.error.main
                                        : theme.palette.gray.main
                                    }
                                  />
                                </IconButton>
                              )}
                            />
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    );
                  }) : stableSort(props.data, getComparator(order, orderBy))
                    .slice()
                    .map((row: any, index: number) => {
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow key={index} hover role="checkbox" tabIndex={-1}>
                          <StyledTableCell id={labelId} scope="row" align="center">
                            {row.partnerName}
                          </StyledTableCell>
                          <StyledTableCell id={labelId} scope="row" align="center">
                            {row.customerName}
                          </StyledTableCell>
                          <StyledTableCell id={labelId} scope="row" align="center">
                            {row.parentId ? `(${row.parentId})` : row.id}
                            {row.description && <HtmlTooltip title={row.description}>
                            <Icon path={mdiInformation} size={0.8}/>
                          </HtmlTooltip>}
                          </StyledTableCell>
                          <StyledTableCell id={labelId} scope="row" align="center">
                            {row.itemsCount}
                          </StyledTableCell>

                          <StyledTableCell align="center">
                            <span>
                              {jMoment(row.deliveryDate, 'YYYY/M/D')
                                .locale('fa')
                                .format('jYY/jMM/jDD')}
                            </span>
                            &nbsp; &nbsp;- &nbsp; &nbsp;
                            <span>
                              {`${jMoment(row.deliveryStartTime, 'HH:mm:ss')
                                .locale('fa')
                                .format('HH')}
                        `}
                              {`تا ${jMoment(row.deliveryEndTime, 'HH:mm:ss')
                                .locale('fa')
                                .format('HH')}`}
                            </span>
                          </StyledTableCell>
                          <StyledTableCell
                            id={labelId}
                            scope="row"
                            align="center"
                          >
                            {row.trackingCode}
                          </StyledTableCell>
                          <StyledTableCell
                            id={labelId}
                            scope="row"
                            align="center"
                          >
                            {showDeliveryType(row.deliveryType)}
                          </StyledTableCell>
                          <StyledTableCell
                            id={labelId}
                            scope="row"
                            align="center"
                          >
                            {showOrderTplType(row.deliveryType, row.orderTplType)}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {translate(row.paymentType, 'cod')}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <Can
                              role={authContext.user.role}
                              perform="orders:changeOrderStatus"
                              yes={() => (
                                <FormControl style={{ width: '100%' }}>
                                  <Icon
                                    path={mdiPencilOutline}
                                    size={1}
                                    className={classes.changStatusIcon}
                                  />
                                  <Select
                                    className={classes.changStatusBox}
                                    fullWidth
                                    name={`status${index}`}
                                    multiple
                                    id={row.rubikaId}
                                    value={[{}]}
                                    IconComponent={() => null}
                                    renderValue={() => (
                                      <span className={classes.renderValue}>
                                        {translate(row.status, 'order')}
                                      </span>
                                    )}
                                  >
                                    <RadioGroup
                                      className={classes.radioGroup}
                                      aria-label={`status${index}`}
                                      name={`status${index}`}
                                      value={'item'}
                                      onChange={(
                                        e: React.ChangeEvent<{ value: unknown }>
                                      ) =>
                                        props.handleOpenConfirmUpdateState({
                                          id: row.id,
                                          body: `${e.target.value}`,
                                        })
                                      }
                                    >
                                      {rulesOrderStatus[row.status].map(
                                        (item: any, index: number) => (
                                          <FormControlLabel
                                            className={classes.radioGroupItem}
                                            key={index}
                                            checked={row.status === item}
                                            value={item}
                                            disabled={
                                              rulesAdminChangeOrderStatus[
                                                authContext.user.role
                                              ].indexOf(item) === -1
                                            }
                                            control={<Radio />}
                                            label={translate(item, 'order')}
                                          />
                                        )
                                      )}
                                    </RadioGroup>
                                  </Select>
                                </FormControl>
                              )}
                              no={() => {
                                return (
                                  <span>{translate(row.status, 'order')}</span>
                                );
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            <div>
                              {row.status === 'ASSIGNED' ? (
                                <Link
                                  to={`/warehouse-operator-orders/${row.id}/pick`}
                                >
                                  <IconButton
                                    aria-label="details"
                                    size="small"
                                    title="جمع آوری سفارش"
                                    data-cy="details"
                                  >
                                    <Icon
                                      path={mdiPlusBoxMultipleOutline}
                                      size={1}
                                      color={theme.palette.orange.main}
                                    />
                                  </IconButton>
                                </Link>
                              ) : null}
                              {row.status === 'PICKED' ? (
                                <Link
                                  to={`/warehouse-operator-orders/${row.id}/pack`}
                                >
                                  <IconButton
                                    aria-label="details"
                                    size="small"
                                    title="بسته بندی سفارش"
                                    data-cy="details"
                                  >
                                    <Icon
                                      path={mdiPackageVariant}
                                      size={1}
                                      color={theme.palette.info.main}
                                    />
                                  </IconButton>
                                </Link>
                              ) : null}
                              <Link to={`/orders/${row.id}`}>
                                <IconButton
                                  aria-label="details"
                                  size="small"
                                  title="جزئیات سفارش"
                                  data-cy="details"
                                >
                                  <Icon
                                    path={mdiFileDocumentOutline}
                                    size={1}
                                    color={theme.palette.green.main}
                                  />
                                </IconButton>
                              </Link>
                              <Can
                                role={authContext.user.role}
                                perform="orders:byBundle"
                                yes={() =>
                                  row.status !== 'ORDERED' && row.status ? (
                                    <Link to={`/bundles/${row.bundleId}`}>
                                      <IconButton
                                        aria-label="bundle"
                                        size="small"
                                        title="نمایش سفارش در بسته "
                                        color="secondary"
                                      >
                                        <Icon
                                          path={mdiPackageVariantClosed}
                                          size={1}
                                          color={theme.palette.blue.main}
                                        />
                                      </IconButton>
                                    </Link>
                                  ) : (
                                    <IconButton
                                      aria-label="bundle"
                                      size="small"
                                      title="بسته‌بندی نشده"
                                      disabled
                                      color="default"
                                      style={{ pointerEvents: 'fill' }}
                                    >
                                      <Icon
                                        path={mdiPackageVariantClosed}
                                        size={1}
                                      />
                                    </IconButton>
                                  )
                                }
                              />
                              <Can
                                role={authContext.user.role}
                                perform="orders:history"
                                yes={() => (
                                  <Link to={`/orders/${row.id}/alllogs`}>
                                    <IconButton size="small" title="تاریخچه سفارش">
                                      <Icon path={mdiHistory} size={1} />
                                    </IconButton>
                                  </Link>
                                )}
                              />
                              <Can
                                role={authContext.user.role}
                                perform="order:assign"
                                yes={() => (
                                  <Link to={`/assign-order/${row.id}`}>
                                    <IconButton size="small" title="اختصاص سفارش">
                                      <Icon
                                        color="#b297a7"
                                        path={mdiAccountArrowLeftOutline}
                                        size={1}
                                      />
                                    </IconButton>
                                  </Link>
                                )}
                              />
                              <Can
                                role={authContext.user.role}
                                perform="orders:cancelOrders"
                                yes={() => (
                                  <IconButton
                                    aria-label="cancele"
                                    title={
                                      row.status === 'CANCELLED'
                                        ? 'لغو شده'
                                        : 'لغو سفارش'
                                    }
                                    size="small"
                                    style={{ pointerEvents: 'fill' }}
                                    disabled={row.status === 'CANCELLED'}
                                  >
                                    <Icon
                                      path={mdiClose}
                                      size={1}
                                      color={
                                        row.status !== 'CANCELLED'
                                          ? theme.palette.error.main
                                          : theme.palette.gray.main
                                      }
                                    />
                                  </IconButton>
                                )}
                              />
                            </div>
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Dialog
        fullWidth
        open={openChangeStatus}
        onClose={() => setOpenChangeStatus(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle> تغییر وضعیت کلی سفارش</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">وضعیت</FormLabel>
            <RadioGroup
              aria-label="status"
              name="Status"
              value={valueStatus}
              onChange={handleChangeValueStatus}
            >
              {rulesOrderStatus[
                props.data.find((data: any) => data.id === selected[0])?.status
              ]?.map((item: Status, index: number) => (
                <FormControlLabel
                  value={item}
                  key={index}
                  control={<Radio key={index} />}
                  label={translate(item, 'order')}
                  disabled={
                    rulesAdminChangeOrderStatus[authContext.user.role].indexOf(
                      item
                    ) === -1
                  }
                />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenChangeStatus(false)}
            variant="contained"
            color="primary"
          >
            {'خیر'}
          </Button>

          <Button
            onClick={changeStatusOrder}
            color="primary"
            variant="outlined"
          >
            {'تغییر وضعیت'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
